import React from 'react';
import NearestItem from './nearest-item';
import Link from "../primitives/link";
import { colors } from '../primitives/colors';
import Skeleton from '../primitives/skeleton/index.tsx';

const algoliaToNearestItem = (fr) => {
    console.log('fr [algoliaToNearestItem]', fr)
    const {
        permalink: frLink,
        average_rating,
        review_count,
        ServicesProvided,
        name: franchiseName,
        mainPhone: franchiseMainPhone
    } = fr.data || {};

    return {
        heading: franchiseName,
        phone: franchiseMainPhone,
        rating: average_rating,
        number_of_reviews: review_count,
        link: { title: 'Find out more >', href: frLink },
        services: ServicesProvided,
    };
};

const NearestMore = (props) => {

    const franchises = props.data;
    return (
        <div css={styles.nearestMoreWrap}>
            <h4 css={styles.nearestTitle}>Nearby Locations</h4>
            {franchises ? (
                franchises
                    .filter((fr, idx) => idx < props.maxItems)
                    .map((fr, idx) => (
                        <>
                            <NearestItem
                                key={idx}
                                data={algoliaToNearestItem(fr)}
                                isFull={false}
                            />
                        </>
                    ))
            ) : (
                <div>
                    <Skeleton css={styles.nearestMorePlaceholder} />
                    <Skeleton css={styles.nearestMorePlaceholder} />
                    <Skeleton css={styles.nearestMorePlaceholder} />
                    <Skeleton css={styles.nearestMorePlaceholder} />
                    <Skeleton css={styles.nearestMorePlaceholder} />

                </div>
            )}
            <Link css={styles.nearestMoreLink} to="/locations">See More Locations ›</Link>
        </div>
    );
};

const styles = {
    nearestTitle: {
        marginBottom: "2.5rem",
        fontSize: "1.875rem",
        lineHeight: "2.25rem",
        fontWeight: 500,
        color: colors.primaryOrange,
    },
    nearestMoreWrap: {
        paddingTop: "2.5rem",
        paddingBottom: "3rem",
        color: colors.shadesBlack,
        width: "100%",
        maxWidth: "465px"

    },
    nearestMoreLink: {
        fontSize: "24px",
        display: "block",
        marginTop: "2.25rem",
        fontWeight: 600,
        color: colors.primaryOrange
    },
    nearestMorePlaceholder: {
        width: "100%",
        height: "70px",
    },
};

export default NearestMore;
